import { createSelector } from 'reselect';
import {
  getDivisionId,
  getPrimaryPriceUnitSlug,
  getVariantsActiveProductWidth,
} from 'features/product-info';

export const getNeedRenderFloorCoveringsComponents = createSelector(
  getDivisionId,
  getPrimaryPriceUnitSlug,
  getVariantsActiveProductWidth,
  (divisionId, primaryPriceUnitSlug, productWidth) => {
    return divisionId === '5' && primaryPriceUnitSlug === 'MTK' && Number.isFinite(productWidth);
  },
);
